import React from 'react';

const ViewportContext = React.createContext({
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight
});

export default ViewportContext;
